import { Component, Input } from '@angular/core'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { PaynowLayoutComponent } from 'src/app/buy-page/paynow/paynow-layout/paynow-layout.component'

@Component({
  selector: 'app-paynow-sicherheit',
  templateUrl: './paynow-sicherheit.component.html',
  styleUrl: './paynow-sicherheit.component.sass',
  imports: [
    PaynowLayoutComponent,
  ],
})
export class PaynowSicherheitComponent {
  @Input() context!: PageContext<RedirectorPaynowConfig>

  protected readonly usps = [{
    icon: 'admin_panel_settings',
    head: $localize`Käufer werden geschützt`,
    body: $localize`Wenn Sie diese Domain über die ELITEDOMAINS GmbH als Treuhänder kaufen, schützen wir Sie mit dem Käuferschutzprogramm und einer Zufriedenheitsgarantie. Der Käufer wird jederzeit durch unseren einmaligen Prozess der Übertragung des Domainbesitzes geschützt. Bei Problemen bekommen Sie immer Ihr Geld zurück.`,
  }, {
    icon: 'fast_forward',
    head: $localize`Schnelle Domainübertragung`,
    body: $localize`Durch unsere automatisierten Prozesse werden 99 % der Domains innerhalb von 24 Stunden übertragen. Nach der Bezahlung übernehmen wir als Treuhänder die Domain direkt vom Verkäufer. Zudem senden wir Ihnen eine kinderleichte Anleitung zur Domain-Übernahme. Falls Sie Hilfe benötigen, helfen unsere Spezialisten beim Domain-Transfer. Entweder per Telefon, Chat oder E-Mail und natürlich immer ohne zusätzliche Kosten.`,
  }, {
    icon: 'lock',
    head: $localize`Sichere Bezahlung`,
    body: $localize`Zahlen Sie schnell und unkompliziert mit Ihrer Kreditkarte. Wir schützen Ihre persönlichen Daten und garantieren eine sichere SSL-Verschlüsselung. Unser Zahlungsabwickler STRIPE gehört zu den sichersten Zahlungsplattformen der Welt, welcher auch Tech-Unternehmen wie AirBnB oder Shopify vertrauen. `,
  }]
}
